import * as React from "react";
import styled from "styled-components";

import { Text } from "src/library/components/Text";

import { ProductSubstitutionStatus } from "../api/substitutions.api";

interface SubstitutionStatusProps {
  status?: ProductSubstitutionStatus;
}

export const SubstitutionStatus: React.ReactFCWithChildren<SubstitutionStatusProps> = ({ status }) => status ? (
  <StatusWrapper status={status}>
    <Text weight="bold">
      {status.replace(/_/g, " ")}
    </Text>
  </StatusWrapper>
) : (
  <StatusWrapper>
    -
  </StatusWrapper>
);

const StatusWrapper = styled("span")<SubstitutionStatusProps>`
  position: relative;

  ${Text} {
    text-transform: capitalize;
    color: ${({ status, theme }) => {
    switch (status) {
      case ProductSubstitutionStatus.Active:
        return theme.colors.success;
      case ProductSubstitutionStatus.DeleteFailed:
        return theme.colors.warn;
      case ProductSubstitutionStatus.Failed:
      case ProductSubstitutionStatus.Deleted:
        return theme.colors.error;
      case ProductSubstitutionStatus.Pending:
      default:
        return theme.colors.draftOrder;
    }
  }};
  }

  .help-icon {
    cursor: help;
    display: inline;
    margin-left: 5px;
  }
`;
